import { render, staticRenderFns } from "./MailTable.vue?vue&type=template&id=4c25a769&scoped=true"
import script from "./MailTable.vue?vue&type=script&lang=js"
export * from "./MailTable.vue?vue&type=script&lang=js"
import style0 from "./MailTable.vue?vue&type=style&index=0&id=4c25a769&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c25a769",
  null
  
)

export default component.exports